<template>
  <div ref="refChartBar"
       style="width: 100%; height: 100%;">
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartBar: null, // 图表指针
      optionBar: {} // 图表参数
    }
  },
  components: {},
  props: {
    updata: {
      type: Object,
      default: () => ({
        seriesData: [
          {
            value: 100,
            name: '总数'
          },
          {
            value: 50,
            name: '在线'
          },
          {
            value: 50,
            name: '离线'
          }
        ]
      })
    }
  },
  mounted() {
    this.initOption()
  },
  beforeDestroy() {
    if (this.chartBar) this.chartBar.dispose()
  },
  watch: {
    updata: {
      handler(newData) {
        this.updateOption(newData)
      },
      // immediate: true, // 初始化后会立即触发一次
      deep: true // 深层监听 即遍历所有子对象 对性能稍有影响
    }
  },
  methods: {
    initOption() {
      this.chartBar = this.$echarts.init(this.$refs.refChartBar)
      this.updateOption(this.updata)
    },
    updateOption(newData) {
      const copyData = newData.seriesData.map((item) => {
        return {
          value: item.value,
          name: item.name,
          borderColor0: item.name.includes('离线') ? '#FCEA10' : '#00FCB0',
          borderColor1: item.name.includes('离线') ? '#FCB41006' : '#14D2B82C',
          color0: item.name.includes('离线') ? '#FCEA10aa' : '#14D2B888',
          color1: item.name.includes('离线') ? '#FCB41006' : '#00FCB000'
        }
      })

      this.optionBar = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'item'
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            show: true, // 显示标签
            color: '#5C9ADD', // 标签颜色
            fontSize: 14, // 字体大小
            fontWeight: 400
            // formatter: '{value} 次', // 格式化标签文本，例如在数值后添加单位
            // rotate: 45 // 标签旋转角度，例如45度
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#4075A5',
              width: 2,
              type: 'solid' // 轴线类型，'solid'（实线）、'dashed'（虚线）、'dotted'（点线）
            }
          },
          data: copyData.map((item) => item.name)
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#5C9ADD',
            fontSize: 14,
            fontWeight: 400
          },
          axisLine: {
            show: false
          },
          splitLine: {
            //背景线条
            show: true,
            lineStyle: {
              color: '#4075A5',
              type: 'dashed'
            }
          }
        },
        series: {
          type: 'pictorialBar',
          symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,5 C4.5,5 4.5,10 0,10 z',
          barCategoryGap: '-5%',
          data: copyData.map((item) => ({
            value: item.value,
            itemStyle: {
              borderWidth: 2,
              borderColor: {
                colorStops: [
                  {
                    color: item.borderColor0,
                    offset: 0
                  },
                  {
                    color: item.borderColor1,
                    offset: 1
                  }
                ],
                global: false,
                type: 'linear',
                x: 0,
                x2: 0,
                y: 0,
                y2: 1
              },
              color: {
                colorStops: [
                  {
                    color: item.color0,
                    offset: 0
                  },
                  {
                    color: item.color1,
                    offset: 1
                  }
                ],
                global: false,
                type: 'linear',
                x: 0,
                x2: 0,
                y: 0,
                y2: 1
              }
            }
          }))
        }
      }

      this.chartBar.setOption(this.optionBar, {
        // notMerge: true, // 不合并以前的配置，直接使用新的配置覆盖
        // lazyUpdate: true // 延迟更新视图，直到下一次渲染循环，这样可以批量更新多个属性而只触发一次重渲染，提高性能。
      })
    }
  }
}
</script>

<style scoped>
</style>